import React from 'react';
import Dialogue from 'components/UI/Dialogue/Dialogue';

const DeleteManagedUserDialogue = (props) => (
  <Dialogue
    subject="DELETE MANAGED ACCOUNT"
    message="Are you sure you want to DELETE this managed user? If so, all the user's logs and posts will be perminantly deleted."
    confirm={props.clicked}
    className="DeleteManagedUser"
    cancelled={props.cancelled}
    cancelText="Cancel"
    confirmationText="Delete"
    dialogueType="alertDialogue"
  />
);

export default DeleteManagedUserDialogue;
